import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { useLazyLoadQuery } from 'react-relay';

import { drawingSetAnnotationListFragment$key } from '../graphql/__generated__/drawingSetAnnotationListFragment.graphql';
import { getDrawingSetAnnotationListQuery as getDrawingSetAnnotationListQueryType } from '../graphql/__generated__/getDrawingSetAnnotationListQuery.graphql';
import { getDrawingSetAnnotationListQuery } from '../graphql/query/get-drawing-set-annotation-list-query';

export const useDrawingSetAnnotation = (updateValue: number, drawingSetSheetId: string = '') => {
    const resultEntityList = useLazyLoadQuery<getDrawingSetAnnotationListQueryType>(
        getDrawingSetAnnotationListQuery,
        {
            first: 1000 + updateValue,
            input: {
                filter: {
                    drawingSheetId: {
                        operator: 'EQ',
                        value: drawingSetSheetId,
                    },
                },
            },
        },
        { fetchPolicy: 'store-or-network' },
    );

    const data = useFragmentFromStore<drawingSetAnnotationListFragment$key>(resultEntityList);

    return data.drawingSetAnnotationList?.edges || [];
};
